import {TrialSalesOffer} from '../../../model/ocapi/trial-sales-offer';
import {Trial} from '../../../model/trial';
import {TrialUtils} from '../../utils/trial/trial-utils';
import {OmapiIdsUtils} from '../../utils/omapi-ids/omapi-ids-utils';

export class TrialSalesOffersMapper {

  static mapToTrials(trialSalesOffers: Array<TrialSalesOffer>, code: string): Array<Trial> {
    const trials = [];
    if (trialSalesOffers) {
      trialSalesOffers.forEach(offer => trials.push(TrialSalesOffersMapper.mapToTrial(offer, code)));
    }
    return trials;
  }

  static mapToTrial(trialSalesOffer: TrialSalesOffer, code: string): Trial {
    let trial;
    if (trialSalesOffer) {
      trial = new Trial();
      if (OmapiIdsUtils.isDwnUser()) {
        trial.omapiId = trialSalesOffer.labelkey;
      } else {
        trial.omapiId = TrialUtils.getTrialOmapiIdForTrialLabel(trialSalesOffer.labelkey);
      }
      trial.duration = trialSalesOffer.duration ? trialSalesOffer.duration.duration : undefined;
      trial.salesOfferingSpecificationId = trialSalesOffer.salesofferingspecificationid;
      trial.label = 'eos-tvshop-' + trialSalesOffer.labelkey;
      trial.voucherid = code;
    }
    return trial;
  }
}
